import Orders from '@/views/Orders/Index'

import OrdersInternalOrders from '@/views/Orders/InternalOrders/Index'
import OrdersInternalOrdersOrder from '@/views/Orders/InternalOrders/Order'
import OrdersInternalOrdersOrderCreate from '@/views/Orders/InternalOrders/OrderCreate'
import OrdersInternalOrdersProduct from '@/views/Orders/InternalOrders/Product'

import OrdersEcommerceOrders from '@/views/Orders/EcommerceOrders/Index'
import OrdersEcommerceOrdersOrder from '@/views/Orders/EcommerceOrders/Order'

import OrdersNonStandardOrders from '@/views/Orders/NonStandardOrders/Index'

import OrdersCooperantOrders from '@/views/Orders/CooperantOrders/Index'
import OrdersCooperantOrdersOrder from '@/views/Orders/CooperantOrders/Order'

import OrdersWMDOrders from '@/views/Orders/WMDOrders/Index'
import OrdersWMDOrdersOrder from '@/views/Orders/WMDOrders/Order'

import OrdersProductTemplates from '@/views/Orders/ProductTemplates/Index'
import OrdersProductTemplatesProductTemplate from '@/views/Orders/ProductTemplates/ProductTemplate'

export default [
    {
        path: '/orders',
        name: 'orders',
        component: Orders,
        meta: {
            title: 'Zamówienia',
            menuRendered: true,
            menuTitle: 'Zamówienia',
            icon: 'mdi-cart-outline',
        },
        children: [
            {
                path: '/orders/internal-orders',
                name: 'ordersInternalOrders',
                component: OrdersInternalOrders,
                meta: {
                    title: 'Zamówienia / Zamówienia komercyjne',
                    menuRendered: true,
                    menuTitle: 'Komercyjne',
                    requiresAuth: true,
                    permission: 'orders'
                }
            },
            {
                path: '/orders/internal-orders/create',
                name: 'ordersInternalOrdersOrderCreate',
                component: OrdersInternalOrdersOrderCreate,
                meta: {
                    title: 'Zamówienia / Zamówienia komercyjne / Nowe zamówienie',
                    requiresAuth: true,
                    permission: 'orders_create',
                },
            },
            {
                path: '/orders/internal-orders/:id',
                name: 'ordersInternalOrdersOrder',
                component: OrdersInternalOrdersOrder,
                meta: {
                    title: 'Zamówienia / Zamówienia komercyjne / Zamówienie',
                    requiresAuth: true,
                    permission: 'orders_read',
                },
            },
            {
                path: '/orders/internal-orders/create/add-product',
                name: 'ordersInternalOrdersAddProduct',
                component: OrdersInternalOrdersProduct,
                meta: {
                    title: 'Zamówienia / Zamówienia komercyjne / Nowe zamówienie / Dodaj produkt',
                    requiresAuth: true,
                    permission: 'orders_create',
                },
            },
            {
                path: '/orders/internal-orders/create/edit-product',
                name: 'ordersInternalOrdersEditProduct',
                component: OrdersInternalOrdersProduct,
                meta: {
                    title: 'Zamówienia / Zamówienia komercyjne / Nowe zamówienie / Edycja produktu',
                    requiresAuth: true,
                    permission: 'orders_update',
                },
            },
            {
                path: '/orders/ecommerce-orders',
                name: 'ordersEcommerceOrders',
                component: OrdersEcommerceOrders,
                meta: {
                    title: 'Zamówienia / Zamówienia eCommerce',
                    menuRendered: true,
                    menuTitle: 'eCommerce',
                    requiresAuth: true,
                    permission: 'orders',
                }
            },
            {
                path: '/orders/ecommerce-orders/:id',
                name: 'ordersEcommerceOrdersOrder',
                component: OrdersEcommerceOrdersOrder,
                meta: {
                    title: 'Zamówienia / Zamówienia eCommerce / Zamówienie',
                    requiresAuth: true,
                    permission: 'orders_read',
                },
            },
            {
                path: '/orders/nonstandard-orders',
                name: 'nonStandardOrders',
                component: OrdersNonStandardOrders,
                meta: {
                    title: 'Zamówienia / Niestandardowe',
                    menuRendered: true,
                    menuTitle: 'Niestandardowe',
                    requiresAuth: true,
                    permission: 'orders',
                }
            },
            {
                path: '/orders/cooperant-orders',
                name: 'ordersCooperantOrders',
                component: OrdersCooperantOrders,
                meta: {
                    title: 'Zamówienia / Kooperacja',
                    menuRendered: true,
                    menuTitle: 'Kooperacja',
                    requiresAuth: true,
                    permission: 'cooperant_orders',
                }
            },
            {
                path: '/orders/wmd-orders',
                name: 'ordersWMDOrders',
                component: OrdersWMDOrders,
                meta: {
                    title: 'Zamówienia / WMD',
                    menuRendered: true,
                    menuTitle: 'WMD',
                    requiresAuth: true,
                    permission: 'wmd_orders',
                }
            },
            {
                path: '/orders/cooperant-orders/:id',
                name: 'ordersCooperantOrdersOrder',
                component: OrdersCooperantOrdersOrder,
                meta: {
                    title: 'Zamówienia / Kooperacja / Zamówienie',
                    requiresAuth: true,
                    permission: 'cooperant_orders_read',
                },
            },
            {
                path: '/orders/wmd-orders/:id',
                name: 'ordersWMDOrdersOrder',
                component: OrdersWMDOrdersOrder,
                meta: {
                    title: 'Zamówienia / WMD / Zamówienie',
                    requiresAuth: true,
                    permission: 'wmd_orders_read',
                },
            },
            {
                path: '/orders/product-templates',
                name: 'ordersProductTemplates',
                component: OrdersProductTemplates,
                meta: {
                    title: 'Konfigurator produktów / Szablony produktowe',
                    menuRendered: true,
                    menuTitle: 'Szablony produktowe',
                    requiresAuth: true,
                    permission: 'product_templates',
                }
            },
            {
                path: '/orders/product-templates/create',
                name: 'ordersProductTemplatesProductTemplateCreate',
                component: OrdersProductTemplatesProductTemplate,
                meta: {
                    title: 'Szablony produktowe / Nowy szablon produktu',
                    requiresAuth: true,
                    permission: 'product_templates_create',
                },
            },
            {
                path: '/orders/product-templates/edit/:id',
                name: 'ordersProductTemplatesProductTemplateEdit',
                component: OrdersProductTemplatesProductTemplate,
                meta: {
                    title: 'Szablony produktowe / Edycja szablonu produktu',
                    requiresAuth: true,
                    permission: 'product_templates_update',
                },
            },
        ]
    }
]